import styled, { css } from 'styled-components';
export const sectionContainerCss = css `
    padding: 2rem 2rem;
`;
export const SectionContainer = styled.div `
    ${sectionContainerCss};

    &.npb {
        padding-bottom: 0;
    }
`;
export const SectionTitle = styled.div `
    font-family: 'Poppins', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 32px;

    &.nmb {
        margin-bottom: 0;
    }
`;
export const forceBreakTextCss = css `
    overflow-wrap: break-word;
    word-wrap: break-word;
    -ms-word-break: break-all;
    word-break: break-all;
    word-break: break-word;
    -ms-hyphens: manual;
    -moz-hyphens: manual;
    -webkit-hyphens: manual;
    hyphens: manual;
`;
export const Button = styled.div `
    cursor: pointer;
    color: ${(props) => props.textColor};
    background-color: ${(props) => props.backgroundColor};

    border-radius: 6.25rem;
    font-family: 'Inter', sans-serif;

    display: 'inline-block';
    align-items: center;
    justify-content: center;
    display: flex;
    text-align: center;

    padding: 1rem 1.5rem;
    font-weight: bold;
    font-size: 0.875rem;
    line-height: 1rem;

    :focus {
        outline: 0 !important;
    }
`;
